import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface CustomerState {
  accessToken: string;
}

const initialState: CustomerState = {
  accessToken: "",
};

const CustomerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    loginCustomer(
      state,
      action: PayloadAction<{ accessToken: string }>
    ) {
      state.accessToken = action.payload.accessToken;
    },
    logoutCustomer(state) {
      state.accessToken = "";
    },
  },
});

export const { loginCustomer, logoutCustomer } = CustomerSlice.actions;
export default CustomerSlice.reducer;
